module.exports = __webpack_public_path__ + "static/img/mobile_middle.af04fbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile_middle.png
// module id = 18Wk
// module chunks = 1